import { FormEvent, PropsWithChildren } from 'react';

interface FormProps<T> extends PropsWithChildren {
  onSubmit: (data: T) => void;
  className?: string;
}

export function Form<T>({ onSubmit, className, children }: FormProps<T>) {
  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const form = e.currentTarget;
    const values = Array.from(new FormData(form).entries());

    // check validity
    const inputs = values.map(([key]) => form.elements.namedItem(key) as HTMLInputElement);
    if (inputs.some((i) => !i.checkValidity())) return;

    const data = values.reduce((prev, [key, value]) => {
      prev[key] = value;
      return prev;
    }, {} as { [key: string]: FormDataEntryValue }) as T;
    onSubmit(data);
  }

  return (
    <form onSubmit={handleSubmit} noValidate className={className}>
      {children}
    </form>
  );
}
